import { useMemo, useState } from 'react';
import { contactChevalier } from '../util/api';

const normalizeString = value => (typeof value === 'string' ? value.trim() : '');

const getCurrentUserName = currentUser => {
  const profile = currentUser?.attributes?.profile || {};
  const firstName = normalizeString(profile.firstName);
  const lastName = normalizeString(profile.lastName);

  return (
    normalizeString(profile.displayName) ||
    [firstName, lastName].filter(Boolean).join(' ') ||
    ''
  );
};

export const useContactChevalierRequest = ({ listing, currentUser }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [inProgress, setInProgress] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const initialValues = useMemo(
    () => ({
      senderName: getCurrentUserName(currentUser),
      senderEmail: normalizeString(currentUser?.attributes?.email),
      message: '',
    }),
    [currentUser]
  );

  const openModal = () => {
    setError(null);
    setSuccess(false);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const submitContactRequest = async values => {
    setInProgress(true);
    setError(null);

    try {
      await contactChevalier({
        listingId: listing?.id?.uuid || listing?.id || null,
        listingTitle: listing?.attributes?.title || '',
        listingUrl: typeof window !== 'undefined' ? window.location.href : '',
        senderName: values?.senderName,
        senderEmail: values?.senderEmail,
        message: values?.message,
        currentUserId: currentUser?.id?.uuid || null,
      });

      setSuccess(true);
      setIsModalOpen(false);
    } catch (e) {
      setError(e);
    } finally {
      setInProgress(false);
    }
  };

  return {
    closeModal,
    error,
    initialValues,
    inProgress,
    isModalOpen,
    openModal,
    submitContactRequest,
    success,
  };
};

export default useContactChevalierRequest;
